
import HttpClient from '../HttpService';

function listModalities() {
    return HttpClient.get(`meta/modalities`);
}

export default {
    listModalities,
}
